const buttonDisabled = (state = false, action) => {
    switch(action.type) {
        case 'buttonDisabled':
            return action.payload;
        default:
            return state;
    }
}

export default buttonDisabled;